import { useForm } from '@magicdoorinc/form';
import type { BetterForm } from '@magicdoorinc/form';

export const usePaymentSelectionForms = () => {
  const formsMap = new Map<string, BetterForm.form>();
  const getForm = (entityId?: string) => {
    if (!entityId) {
      return;
    }

    const _form = formsMap.get(entityId);
    if (_form) {
      return _form;
    }
    const form = useForm({
      validateTriggers: ['onChange'],
    });
    formsMap.set(entityId, form);
    return form;
  };

  const hasPaymentCheckError = () => {
    for (const form of formsMap.values()) {
      const { validateStatus } = form.validateForm();
      if (!validateStatus) {
        return true;
      }
    }
  };

  const clearForm = (entityId?: string) => {
    if (!entityId) {
      return formsMap.clear();
    }
    formsMap.delete(entityId);
  };

  return {
    getForm,
    hasPaymentCheckError,
    clearForm,
  };
};
